import bemBlock, { useBemCN } from '@gik/core/utils/bemBlock';
import { HTMLParser, SvgIcon, UI } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '../../i18n/en';

interface IPremiumPageUpgradeThankYouProps {
  hasBorder?: boolean;
}

export default function PremiumPageUpgradeThankYou({ hasBorder = true }: IPremiumPageUpgradeThankYouProps) {
  const { t } = useTranslation();
  const bem = useBemCN('premium-page-upgrade-thank-you');

  function renderPremiumBenefit(description: string) {
    return (
      <div {...bem('premium-benefit')}>
        <SvgIcon name="LockOpen" />
        <p>
          <HTMLParser rawHtml={description} />
        </p>
      </div>
    );
  }

  return (
    <div {...bem(undefined, undefined, [{ 'has-border': hasBorder }])}>
      <p {...bem('heading')}>{t(translationKeys.PremiumPageThankYouTitle)}</p>
      <p {...bem('subheading')}>{t(translationKeys.PremiumPageUnlockedBenefits)}</p>
      {renderPremiumBenefit(t(translationKeys.PremiumPageSupporterViewBenefit))}
      {renderPremiumBenefit(t(translationKeys.PremiumPageRemoveSuggestionsBenefit))}

      <p {...bem('footer-message')}>{t(translationKeys.PremiumPageThankYouFooterMessage)}</p>
    </div>
  );
}

export function openPremiumPageThankYouModal() {
  const bem = bemBlock('premium-page-upgrade-thank-you-modal');
  return UI.dialog(
    () => {
      return <PremiumPageUpgradeThankYou hasBorder={false} />;
    },
    { closable: true, className: bem() }
  );
}
